import assignBooking from './assignBooking';
import assignError from './assignError';

export default {
    assignBooking,
    assignError,
};
